﻿
const registrationTypeTypes = {
    Myself: {
        name: "Myself", value: "Individual (Myself)"
    },
    SomeoneElse: {
        name: "Someone else", value: "Individual (Someone Else)"
    },
    Company: {
        name: "Company/Business", value: "Company/Business"
    },
    Trust: {
        name: "Trust", value: "Trust"
    },
};

const registrationTypeOptions = [
    { name: registrationTypeTypes.Myself.name, value: registrationTypeTypes.Myself.value },
    { name: registrationTypeTypes.SomeoneElse.name, value: registrationTypeTypes.SomeoneElse.value },
    { name: registrationTypeTypes.Company.name, value: registrationTypeTypes.Company.value },
    { name: registrationTypeTypes.Trust.name, value: registrationTypeTypes.Trust.value },
];

const registrationTypes = {
    types: registrationTypeTypes,
    options: registrationTypeOptions,
};

export default registrationTypes;
